import Vue from 'vue'
import {
  CheckboxGroup, Checkbox, RadioGroup, Radio, Icon, Button, Tabbar, TabbarItem,
  CellGroup, Cell, Popup, Picker, DatetimePicker, Field,
  DropdownMenu, DropdownItem, Toast, Tab, Tabs, Dialog,
  Sidebar, SidebarItem, Swipe, SwipeItem
} from 'vant'
import 'vant/lib/index.less'
import './theme.less'
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(DatetimePicker)
Vue.use(Field)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Toast)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Dialog)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Swipe)
Vue.use(SwipeItem)



// WEBPACK FOOTER //
// ./src/components/vant/index.js